<template>
    <div id="page_06" class="page">
        <div class="content">
            <div class="content_area">
                <div class="item_wrap item_left">
                    <div class="item">
                        <img src="@/assets/img/img_page_06_01.png" style="width:5.38rem;" />
                    </div>
                    <div class="item" style="margin-left:1.12rem;">
                        <p style="font-size:0.68rem;font-weight:bold;">
                            상권에 따른 선호 브랜드 공급
                        </p>
                        <p style="font-size:0.54rem;line-height:0.82rem;">
                            가맹 지역과 상권에 대한 철저한 사전조사로 지역별<br/>
                            선호 브랜드 입점을 통해 차별성 제공
                        </p>
                    </div>
                    <div class="clear"></div>
                </div>
                <div class="item_wrap item_right">
                    <div class="item">
                        <img src="@/assets/img/img_page_06_02.png" style="width:4.54rem;" />
                    </div>
                    <div id="item_06_02" class="item">
                        <p class="sub">
                            사입 리스크 최소화 &amp; 온라인을 통한 재고 햇징
                        </p>
                        <p class="desc">
                            부진 재고의 발생을 최소화 하기 위해 일부 상품의 위탁 공급 진행<br/>
                            스페시맨 온라인 스토어를 통한 가맹점의 부진재고 위탁판매
                        </p>
                    </div>
                    <div class="clear"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Page06'
}
</script>

<style scoped>
    .content{background-image:url("../assets/img/bg_page_06.jpg");padding-top:3.7rem;padding-bottom:3.56rem;}
    .item>p{font-size:0.88rem;line-height:0.5rem;}
    .item>p>span{border-bottom:0.1rem solid #000;}
    .item>img{width:10.096rem;height:auto;}
    .item_right>.item{margin-top:2.84rem;}
    #item_06_02>p.sub{font-size:0.68rem;font-weight:bold;}
    #item_06_02>p.desc{font-size:0.54rem;line-height:0.82rem;}    

    @media (min-width:721px) {
        #item_06_02{margin-right:1.09rem;}
        #item_06_02>p{text-align:right;}
        .item_right{margin-right:5.918rem;}
        .item_right>.item{float:right !important;}
    }
</style>